import template from './log.all.html';
import controller from './log.all.controller';
import './log.all.scss';

let logallComponent = {
  restrict: 'E',
  bindings: {
    hasACL: '='
  },
  template,
  controller
};

export default logallComponent;


// WEBPACK FOOTER //
// ./client/app/components/log/all/log.all.component.js